<template>
  <div
    :class="[stat == true ? 'main-container-wrapper bac' : 'main-container']"
  >
    <div class="main-container-wrapper h">
      <div class="flex-content-space-between">
        <div class="left-content">
          <img src="../assets/menu_logo.png" alt="" />
          <ul class="horizontal-ul">
            <template v-for="nav in menuNavOptions">
              <li
                :key="nav.title"
                v-if="!nav.hidden"
                :class="{ 'nav-active': nav.active }"
              >
                <a
                  style="font-size: 18px"
                  href="javascript:void(0)"
                  @click.prevent.stop="navigationTo(nav)"
                  class=""
                  >{{ nav.title }}</a
                >
              </li>
            </template>
            <!--                        -->
            <!--                        <li class="active">-->
            <!--                            <a href="/Home" class="">首页</a>-->
            <!--                        </li>-->
            <!--                        <li>-->
            <!--                            <a href="/admin-license" class="">行政审批</a>-->
            <!--                        </li>-->
            <!--                        <li>-->
            <!--                            <a href="/industry-manage">行业监管</a>-->
            <!--                        </li>-->
            <!--                        <li>-->
            <!--                            <a href="/office-public" class="">信息公开</a>-->
            <!--                        </li>-->
            <!--                        <li>-->
            <!--                            <a href="/public-service" class="">公共服务</a>-->
            <!--                        </li>-->
          </ul>
        </div>
        <div class="right-content">
          <ul class="horizontal-ul">
            <li :class="{ 'nav-actives': navActiveFlag }">
              <a @click="zaixianbanshi()">在线办事入口</a>
            </li>
            <!-- <li>|</li> -->
            <!-- <li>
              <a :href="url+'?type=3'">审批监管入口</a>
            </li> -->
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { jumpAddress } from "../utils/axiosUrl";
export default {
  name: "MainMenuBar",
  data() {
    return {
      url: jumpAddress,
      navActiveFlag: false,
      menuNavOptions: [
        { title: "首页", path: "/Home", active: true, hidden: false },
        {
          title: "行政审批",
          path: "/admin-license",
          active: false,
          hidden: false,
        },
        {
          title: "行业监管",
          path: "/industry-manage",
          active: false,
          hidden: false,
        },
        {
          title: "信息公开",
          path: "/office-public",
          active: false,
          hidden: false,
        },
        {
          title: "公共服务",
          path: "/public-service",
          active: false,
          hidden: false,
        },
      ],
    };
  },
  props: ["stat"],
  mounted() {
    this.clearNavActiveStatus();
    var navTitle = "";
    if (!sessionStorage.getItem("curNav")) {
      navTitle = "首页";
    } else {
      navTitle = sessionStorage.getItem("curNav");
    }
    let findMenuNav = this.menuNavOptions.find((nav) => navTitle === nav.title);
    if (findMenuNav) {
      findMenuNav.active = true;
    }
  },
  methods: {
    zaixianbanshi() {
      this.menuNavOptions.forEach((item) => {
        item.active = false;
      });
      this.navActiveFlag = true;
      this.$router.push({
        path: "/Online-service",
        query: {},
      });
    },
    navigationTo(nav) {
      this.navActiveFlag = false;
      this.$router.push(nav.path).then(() => {
        this.clearNavActiveStatus();
        nav.active = true;
        sessionStorage.setItem("curNav", nav.title);
      });
    },
    clearNavActiveStatus() {
      this.menuNavOptions.forEach((nav) => (nav.active = false));
    },
  },
};
</script>

<style scoped lang="less">
@import "../styles/theme";
.h {
  width: 1150px;
}
.bac {
  background: @theme-color;
}
.main-container {
  background: @theme-color;
  height: @height-menu-bar;
}
.left-content {
  img {
    vertical-align: middle;
    /*margin: 0 1rem;*/
    margin: -2px 0 0 16px;
    position: relative;
    z-index: 10;
  }
  ul {
    margin: 0;
    display: inline-block;
    li {
      position: relative;
      display: inline-block;
      font-size: 16px;
      font-weight: 700;
      line-height: @height-menu-bar;
      color: #fff;
      cursor: pointer;
    }

    li.nav-active:after {
      border-bottom-color: #fff;
    }
    li:after {
      position: absolute;
      content: "";
      left: 50%;
      bottom: 0;
      border: 6px solid transparent;
      -webkit-transform: translateX(-50%);
      transform: translateX(-50%);
    }

    a {
      padding: 0 2.5rem;
    }
  }
}
.horizontal-ul {
  li {
    font-size: 16px;
    font-weight: 700;
  }
}

.right-content {
  li {
    position: relative;
    display: inline-block;
    line-height: @height-menu-bar;
    font-size: 18px;
    color: #fff;
    cursor: pointer;
  }

  li.nav-actives:after {
    border-bottom-color: #fff;
  }
  li:after {
    position: absolute;
    content: "";
    left: 50%;
    bottom: -1px;
    border: 6px solid transparent;
    -webkit-transform: translateX(-50%);
    transform: translateX(-50%);
  }

  a {
    padding: 0 1rem;
  }
}
</style>
